




















































    
import {Vue, Component, Prop} from 'vue-property-decorator';
import { ClientProject } from '../../../services/accounting.service';

@Component({})
export default class ClientProjectsList extends Vue {
    @Prop()
    public projects!: ClientProject[];

    public estHours(project: ClientProject) {
        let sum = 0;
        for (const task of project.tasks) {
            sum += task.estimatedHours;
        }
        return sum;
    }

    public actHours(project: ClientProject) {
        let sum = 0;
        for (const task of project.tasks) {
            sum += task.actualHours;
        }
        return sum;
    }

    public billedHours(project: ClientProject) {
        let sum = 0;
        for (const task of project.tasks) {
            sum += task.billedHours;
        }
        return sum;
    }
}

